import * as React from "react";
import { CountBadge, Spinner } from "components/common";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import { useInputMetricsFor } from "components/inputs/InputsOveriew/InputMetricsContext";
import { METRIC_COLUMN_IDS } from "components/inputs/InputsOveriew/metricColumns";
const SECTION_NAME = METRIC_COLUMN_IDS.messagesPerStream;
const sumValues = (counts) => Object.values(counts).reduce((sum, value) => sum + value, 0);
const MessageCountCell = ({ input }) => {
  var _a, _b;
  const { metrics, isInitialLoading, isError } = useInputMetricsFor(input.id);
  const { toggleSection, expandedSections } = useExpandedSections();
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (isError || !(metrics == null ? void 0 : metrics.messages_per_stream)) {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": `No message count available for input ${input.title}` }, "\u2014");
  }
  const total = sumValues(metrics.messages_per_stream);
  const isOpen = (_b = (_a = expandedSections == null ? void 0 : expandedSections[input.id]) == null ? void 0 : _a.includes(SECTION_NAME)) != null ? _b : false;
  const title = `${isOpen ? "Hide" : "Show"} messages per stream for ${input.title}`;
  return /* @__PURE__ */ React.createElement(
    CountBadge,
    {
      count: total,
      abbreviate: true,
      iconName: isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down",
      onClick: () => toggleSection(input.id, SECTION_NAME),
      title
    }
  );
};
export default MessageCountCell;
